module.exports = __webpack_public_path__ + "img/dum4.fbc256fa.png";